module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/ko/5-2c13aedbfcf994c757ed1a40a114098a.jpg";